import { Flex, Text } from "@radix-ui/themes";
import { twMerge } from "tailwind-merge";

type InstructionsCardProps = {
  image: string | React.ReactNode;
  title: string | React.ReactNode;
  moreButton?: React.ReactNode;
  imgClassName?: string;
  wrapperClassName?: string;
  onClick?: () => void;
};

export function InstructionCard({
  image,
  title,
  onClick,
  moreButton,
  imgClassName,
  wrapperClassName,
}: InstructionsCardProps) {
  return (
    <Flex
      onClick={onClick}
      className={twMerge([
        "basis-1/3 bg-[#F5F5F5] border border-[#E5E5E5] rounded-2xl",
        wrapperClassName,
      ])}
    >
      <Flex
        direction="column"
        align="center"
        className="h-full !justify-center"
      >
        {typeof image === "string" ? (
          <div className="img-mask">
            <img
              src={image}
              className={twMerge([
                "object-contain w-full min-h-[395px] pointer-events-none select-none",
                imgClassName,
              ])}
            />
          </div>
        ) : (
          image
        )}
        {typeof title === "string" ? (
          <Flex mt="7" mb="3" px="4">
            <Text size="6" weight="medium">
              {title}
            </Text>
          </Flex>
        ) : (
          title
        )}
        {moreButton}
      </Flex>
    </Flex>
  );
}
